/*
Infinite scroll for the post lists (index, tag, author). A hidden sentinel near the bottom
is observed; when it approaches the viewport the next page is fetched and its cards are
appended. When there are no more pages the compact Назад/Дальше nav is hidden and an end
note is shown.

Robustness: without JS (or if a fetch fails) the server-rendered .mnr-pagination Назад/Дальше
links remain real <a href> — fully functional pagination and crawlable for SEO. Clicking
"Дальше" with JS loads inline instead of navigating.
*/

import populateCardThumbnails from "./cardThumbnails";

export default function loadMore() {
    const feed = document.querySelector('.gh-postfeed');
    if (!feed) return;

    const sentinel = document.querySelector('[data-feed-sentinel]');
    const nextLink = document.querySelector('[data-load-next]');
    const pagination = document.querySelector('[data-pagination]');
    const endNote = document.querySelector('[data-feed-end]');

    let nextUrl =
        (nextLink && nextLink.getAttribute('href')) ||
        document.querySelector('link[rel="next"]')?.getAttribute('href') ||
        null;

    if (!nextUrl) return;

    let loading = false;
    let observer = null;

    const finish = () => {
        if (observer) observer.disconnect();
        if (pagination) pagination.hidden = true;
        if (sentinel) sentinel.remove();
        if (endNote) endNote.hidden = false;
    };

    async function load() {
        if (loading || !nextUrl) return;
        const url = nextUrl;
        loading = true;

        let doc;
        try {
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) throw new Error('Request failed: ' + res.status);
            doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        } catch (error) {
            // Network/HTTP failure: fall back to normal navigation so the reader always advances.
            console.error('[loadMore] falling back to navigation:', error);
            window.location.assign(url);
            return;
        }

        const incoming = doc.querySelectorAll('.gh-postfeed > *');
        const fragment = document.createDocumentFragment();
        incoming.forEach((node) => fragment.appendChild(document.importNode(node, true)));
        feed.appendChild(fragment);
        populateCardThumbnails(feed);

        nextUrl = doc.querySelector('link[rel="next"]')?.getAttribute('href') || null;
        loading = false;

        if (nextUrl) {
            if (nextLink) nextLink.setAttribute('href', nextUrl);
        } else {
            finish();
        }
    }

    // Clicking "Дальше" loads inline instead of navigating (plain left-click only).
    if (nextLink) {
        nextLink.addEventListener('click', (event) => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            load();
        });
    }

    // Infinite scroll: load the next page as the sentinel approaches the viewport.
    if (sentinel && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(
            (entries) => entries.forEach((entry) => entry.isIntersecting && load()),
            { rootMargin: '800px 0px' }
        );
        observer.observe(sentinel);
    }
}
